import template from './add_company_obj.html';
import * as Utils from '../../lib/savanna_utils.js';

class AddCompanyObjViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.mission = ko.observable();
		this.number = ko.observable();
		this.company_objectives = ko.observableArray();

		this.max_num = ko.computed(() => {
			return this.company_objectives().length + 1;
		});
	};

	close()
	{
		this.dialog.close();
	}

	async btn_save_obj()
	{
		if (!this.number())
			this.number(null);
		else
		{
			try {
				this.number(parseInt(this.number()));
			} catch (error) {
				Grape.alerts.alert({ type: 'warning', message: 'Number is not valid.'});
				return;
			}
		}
		if (!this.mission())
		{
			Grape.alerts.alert({ type: 'warning', message: 'Mission & vision cannot be empty!'});
			return;
		}
		else
		{
			try {
				let res = await Grape.fetches.postJSON('/performance_management/company_objectives/edit', {
					mission: this.mission(),
					number: this.number()
				});
				if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: 'Successfully saved new company objective'});
					this.dialog.close(true);
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({ type: 'error', message: 'An error occurred - ', error});
			}
		}
	}
};

class AddCompanyObjPage
{
	constructor (bindings)
	{
		this.viewModel = new AddCompanyObjViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
		this.viewModel.company_objectives(this.bindings.data);
		this.viewModel.number(this.viewModel.company_objectives().length + 1);
	}

	async updateData()
	{}
};

export default {
	name: 'AddCompanyObj',
	dialog_class: AddCompanyObjPage,
	template: template,
	template_filename: 'translation/dialogs/add_company_obj',
	provider: 'ps'
};